import { InputProps } from '../OdfjellInputComponent';

const TextInputComponent: React.FC<Partial<InputProps>> = ({ value, name, elementId, onChange }: Partial<InputProps>) => {
    return (
        <input
            type="text"
            value={value}
            name={name}
            id={elementId}
            onChange={(event) => onChange({ event })}
            autoComplete="off"
            maxLength={195}
        ></input>
    );
};

export default TextInputComponent;
